import types from '@/types';

const data = {
  notification: {
    message: '',
    color: 'info',
    show: false,
  },
  busy: {
    message: '',
    show: false,
  },
};

const mutations = {
  [types.SHOW_INFORMATION](state, message) {
    state.notification.message = message;
    state.notification.color = 'info';
    state.notification.show = true;
  },
  [types.SHOW_SUCCESS](state, message) {
    state.notification.message = message;
    state.notification.color = 'success';
    state.notification.show = true;
  },
  [types.SHOW_WARNING](state, message) {
    state.notification.message = message;
    state.notification.color = 'warning';
    state.notification.show = true;
  },
  [types.SHOW_ERROR](state, message) {
    state.notification.message = message;
    state.notification.color = 'error';
    state.notification.show = true;
  },
  [types.HIDE_NOTIFICATION](state) {
    state.notification.show = false;
  },
  [types.SHOW_BUSY](state, message) {
    state.busy.message = message;
    state.busy.show = true;
  },
  [types.HIDE_BUSY](state) {
    state.busy.show = false;
  },
};

const actions = {
};

export default {
  namespaced: true,
  state: data,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/app.js